export const isModalView = () => {
    return (
        window.location.hash.startsWith('#/modal')
    );
};
